import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveGoogleLocationMappings } from "../../api/bReviewsApi";

export const useSaveGoogleLocationMappings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["save-google-location-mappings"],
    mutationFn: (data) => saveGoogleLocationMappings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["google-location-mappings"] });
      queryClient.removeQueries({ queryKey: ["review-competitors"] });
    },
    onError: (error) => {
      console.error("Google location mapping save error:", error.response || error);
    },
  });
};
